import { render } from "./DigiQLandingView.vue?vue&type=template&id=78975528"
import script from "./DigiQLandingView.vue?vue&type=script&lang=js"
export * from "./DigiQLandingView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__